import {
    REQUEST_BILLING_DETAILS,
    REQUEST_BILLING_DETAILS_FAILURE,
    REQUEST_BILLING_DETAILS_SUCCESS
} from "../../../constant/transaction/BillingDetailContant";


const initialState = {
    billingDetails: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const billingDetailsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_BILLING_DETAILS:
            return {
                ...state,
                billingDetails: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_BILLING_DETAILS_SUCCESS:
            return {
                ...state,
                billingDetails: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_BILLING_DETAILS_FAILURE:
            return {
                ...state,
                billingDetails: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
